// extracted by mini-css-extract-plugin
module.exports = {"root":"dashboardLink_root__2jdyS","link":"dashboardLink_link__30H-V"};